import { makeStyles } from '@material-ui/core/styles';

const PostSummaryStyles =
    makeStyles((theme) => ({
        postSummaryContainer: {
            backgroundColor: `${theme.palette.background.paper} !important`,
            display: "flex",

            [theme.breakpoints.only("md")]: {
                height: "370px",
            },
            [theme.breakpoints.only("lg")]: {
                height: "350px",
            },
            [theme.breakpoints.only("xl")]: {
                height: "330px",
            },
        },
        postSummaryTitleStyle: {
            /*whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",*/
            marginBottom: theme.spacing(2),
        },
        postSummaryInfoContainer: {
            color: theme.palette.text.secondary,
            width: "50%",
            padding: theme.spacing(5),
            position: "relative",
        },
        postImgContainerStyles: {
            width: "50%",
            maxWidth: "50%",
            verticalAlign: "middle",
            display: "flex",
        },
        link: {
            position: "absolute",
            bottom: theme.spacing(4),
            left: theme.spacing(6),
        }
    }));

export default PostSummaryStyles;
